<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";

import { mapGetters, mapActions } from "vuex";

export default {
  page: {
    title: "VISITS REPORT",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },

  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      filtered_array: [],
      filterstatus: false,
      filterreport: {
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
        service_id: "0",
        total_cost: 0,
      },
      title: "LAB PERFORMANCE REPORT",
      items: [
        {
          text: "FACILITY REPORTS",
          href: "#",
        },
        {
          text: "LAB PERFORMACE REPORT",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "service",
          sortable: true,
          label: "SERVICE",
        },

        {
          key: "cost",
          sortable: true,
          label: "COST",
        },
        {
          key: "time",
          sortable: true,
          label: "TIME",
        },
      ],
      json_fields: {
        BRANCH: "branch",
        DATE: "date",
        SERVICE: "service",
        COST: "cost",
        TIME: "time",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    ...mapGetters("reports", ["lab_performance_report"]),
    ...mapGetters("services", ["labServices"]),

    rows() {
      return this.filtered_array ? this.filtered_array.length : 1;
    },
  },
  watch: {
    lab_performance_report(newValue) {
      if (newValue.length > 0) {
        this.fill_lab_performance();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filtered_array ? this.filtered_array.length : 1;
  },

  methods: {
    ...mapActions({
      FetchLabPerformanceReport: "reports/fetchLabPerformanceReport",
      FetchLabServices: "services/fetchLabServices",
    }),
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    fill_lab_performance() {
      this.filtered_array = this.lab_performance_report
        ? this.lab_performance_report
        : [];
      this.gettotals();
    },
    FilterRepo() {
      let startDate = this.filterreport.date1;
      let endDate = this.filterreport.date2;
      let test_id = this.filterreport.service_id;

      if (startDate != "" && endDate != "" && test_id == "") {
        this.filtered_array = this.lab_performance_report.filter((pymts) => {
          return pymts.filter_date >= startDate && pymts.filter_date <= endDate;
        });
      } else if (startDate != "" && endDate != "" && test_id != "") {
        this.filtered_array = this.lab_performance_report.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            pymts.service_id == test_id
          );
        });
      } else if (startDate == "" && endDate != "" && test_id != "") {
        this.filtered_array = this.lab_performance_report.filter((pymts) => {
          return pymts.filter_date <= endDate && pymts.service_id == test_id;
        });
      } else {
        this.filtered_array = this.lab_performance_report;
      }

      this.gettotals();
    },

    gettotals() {
      let total_amt = 0;
      this.filtered_array.forEach((value) => {
        var total1 = value.cost;
        var total2 = total1.replace(",", "");
        var total = parseInt(total2);
        total_amt = total_amt + total;
      });
      this.filterreport.total_cost = this.thousandSeprator(total_amt);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },

  created() {
    this.fill_lab_performance();
    this.FetchLabPerformanceReport();
    this.FetchLabServices();
  },
};
</script>

<style lang="css" scoped></style>

<template>
  <Layout>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            {{ title }}<br />

            {{ total_cost }}

            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                  @change="FilterRepo()"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  v-model="filterreport.date2"
                  @change="FilterRepo()"
                  type="date"
                  class="form-control m-1"
                />
              </div>

              <div class="col-md-4 form-group">
                <label>Test</label>

                <model-list-select
                  :list="labServices ? labServices : []"
                  v-model="filterreport.service_id"
                  option-value="id"
                  @input="FilterRepo()"
                  option-text="serviceName"
                  placeholder="select"
                >
                </model-list-select>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <download-excel
                  class="btn btn-primary mb-1"
                  :data="filtered_array"
                  :fields="json_fields"
                  :worksheet="'LAB PERFORMANCE REPORT' + currentdate"
                  type="csv"
                  :name="'labperformancereport_' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                foot-clone
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="filtered_array ? filtered_array : []"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(dateTime)="data">
                  {{ data.item.dateCreated }}({{ data.item.time }})
                </template>
                <template #cell(age)="data">
                  {{ data.item.age }}
                  <span v-if="data.item.age_unit == 1">years</span>
                  <span v-else-if="data.item.age_unit == 2">Month</span>
                  <span v-else-if="data.item.age_unit == 3">Days</span>
                  <span v-else>--</span>
                </template>
                <template #cell(services)="data">
                  <span
                    v-for="(test, index) in data.item.labrequests
                      ? data.item.labrequests
                      : []"
                    :key="index"
                    ><span class="compla"
                      ><div>{{ test.test.name, }},</div></span
                    ></span
                  >
                  <span
                    v-for="(test, index) in data.item.completetests
                      ? data.item.completetests
                      : []"
                    :key="index"
                    ><span class="compla"
                      ><div>{{ test.test.name, }},</div></span
                    ></span
                  >
                  <span v-for="(service, index) in data.item.patientservices" :key="index"
                    ><span class="compla"
                      ><div>{{ service.service.name }},</div></span
                    ></span
                  >
                  <span
                    v-for="(prescription, index) in data.item.prescriptions"
                    :key="index"
                    ><span class="compla"
                      ><div>{{ prescription.item.serviceName }},</div></span
                    ></span
                  >
                </template>
                <template #foot(cost)="">
                  Total <span class="text-dark"> {{ filterreport.total_cost }}</span>
                </template>

                <template #foot(branch)=""> <span class="text-danger"></span></template>
                <template #foot(service)=""> <span class="text-danger"></span></template>
                <template #foot(time)=""> <span class="text-danger"></span></template>
                <template #foot(index)=""> <span class="text-danger"></span></template>
                <template #foot(date)=""> <span class="text-danger"></span></template>
              </b-table>
              <h3 v-if="!this.lab_performance_report" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
